/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $SatisfactionSurveyDetail = {
    properties: {
        id: {
    type: 'number',
    isRequired: true,
},
        name: {
    type: 'string',
    isRequired: true,
},
        details: {
    type: 'array',
    contains: {
        type: 'ResponseSatisfactionSurveyData',
    },
    isRequired: true,
},
    },
};